module.exports = __webpack_public_path__ + "img/va.6182350.svg";